import { Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyService } from '../../services/currency.service';

/**
 * Return amount & currency for exist locale
 *
 * Exapmle
 *
 * DE, DE-AT ->
 *  input: € 100
 *  output: 100 €
 */
@Pipe({
    name: 'currencyLocale',
})
export class CurrencyLocalePipe implements PipeTransform {
  private _currency = inject(CurrencyService);


  transform(value: any, currency: string, space = ' '): any {
    return value ? this._currency.transformLocaleCurrency(value, currency, space) : '';
  }

}
